import React from 'react';
import ClickMark from './ClickMark';

const colors = ['#caa1eb', '#f7a38c', '#94b6e8', '#eadb8a'];

function SectionKicker({children, tone = 0, light = false}) {
  return (
    <span className={light ? 'kicker light kicker-mark' : 'kicker kicker-mark'}>
      <ClickMark className="kicker-icon" color={colors[tone % colors.length]} />
      {children}
    </span>
  );
}

export default SectionKicker;